const CAMPAIGN_EMAIL_TEMPLATE_TYPES = Object.freeze({
    WELCOME: 'welcome',
    SIGNUP_PAGE_CONFIRMATION: 'signupPageConfirmation',
});

module.exports = {
    CAMPAIGN_EMAIL_TEMPLATE_TYPES,
};
